export const VerificationStatus = Object.freeze(
    {
        START : "Start",
        IMAGE_UPLOADED : "Image uploaded",
        PROCESSED : "Processed",
        NO_FACE_DETECTED : "No face detected",
        FACE_DETECTED : "Face detected",
        MANUAL_OVERRIDE : "Manually overridden",
        NO_FACE_MATCH : "Faces do not match",
        FACE_MATCH : "Faces match",
        MANUAL_VERIFICATION : "Manually verified",
        UNVERIFIED : "Unverified",
        ERROR : "Error",
        SERVICE_UNAVAILABLE : "Service unavailable"
    }
)

export const WorkflowType = Object.freeze(
    {
        PATIENT_REFERENCE : "patient_reference",
        BOOKING_VERIFICATION : "booking_verification",
        PROCEDURE_VERIFICATION : "procedure_verification"
    }
)


// verification status
// is verifying
//
//
// workflowType
//
// activeStep
